import React from "react";
import PropTypes from "prop-types";
import "./styles.css";

const HomePageTable = (props) => {
  const { children } = props;
  return <div className="home-page-table">{children}</div>;
};

HomePageTable.defaultProps = {
  children: null,
};

HomePageTable.propTypes = {
  children: PropTypes.element,
};

export default HomePageTable;
